<template>
  <div class="sm-bank-integration">
    <div class="sm-bank-integration__main">
      <h5>Spheremail uses Plaid to link your bank</h5>
      <ul class="sm-bank-integration__main-list">
        <li>
          <h6>Secure</h6>
          <span class="sm-small">Transfer of your information is encrypted end-to-end</span>
        </li>
        <li>
          <h6>Private</h6>
          <span class="sm-small">Your credentials will never be made accessible to Spheremail</span>
        </li>
      </ul>

      <plaid-wrap
        v-if="!bankData"
        :linkToken="linkToken"
        @success="handleSuccess"
      >
        <template slot="button">
          <button class="sm-btn">Select</button>
        </template>
      </plaid-wrap>
      <div 
        v-else
        class="sm-bank-integration__main-done"
      >
        <btn-block
          :type="'button'"
          :text="'Selected'"
          :class="'disabled'"
        />
        <a
          href="#"
          class="sm-link sm-error"
          @click.prevent="handleDelete"
        >Delete</a>
      </div>

      <span class="sm-tiny disabled">Bank Account payment may take up to five(5) business days to be confirmed.</span>
    </div>

    <div class="sm-bank-integration__bottom sm-small">
      <span class="disabled">By clicking “Select” you agree to the </span>
      <a
        :href="plaidLink"
        target="_blank"
      >Plaid End User Privacy Policy</a>
    </div>
  </div>
</template>

<script>
import Urls from '@/settings/urls';
import PlaidWrap from '@/components/bank-account/PlaidWrap';

export default {
  name: 'bank-integration',
  components: {
    'plaid-wrap': PlaidWrap
  },
  props: {
    linkToken: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bankData: null,
      plaidLink: Urls.external.plaid_legal
    }
  },
  computed: {
    
  },
  created() {
    
  },
  beforeDestroy() {
    this.handleDelete();
  },
  methods: {
    handleSuccess(data) {
      this.bankData = data;
      this.$emit('bankData', this.bankData);
    },
    handleDelete() {
      this.bankData = null;
      this.$emit('bankData', null);
    }
  }
}
</script>